import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { StringUtility } from "../../../system/StringUtility";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { PtKanaBehavior } from "./PtKanaBehavior";

/** HIS項目患者カナ・姓を生成する */
export class PtKanaSeiBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_KANA_SEI";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtKanaSeiBehavior.Key).map(x => x.value);
    const behavior = new PtKanaBehavior();
    const values = behavior.getValue(hisInfoItems).data as string[];
    const sei = values.map(x => StringUtility.getTextBeforeSpace(x));
    const data = itemValues.length > 0 ? itemValues : sei;
    return new HisInformationTextValue(PtKanaSeiBehavior.Key, data);
  }
}
